import React from "react";

const OptionThesaurus = ({ children, innerRef, innerProps, isFocused, ...props }) => {
  const { label, parentHierarchy = "", remissives = [] } = props.data;
  const inputValue = props.selectProps.inputValue.toLowerCase();
  const validRemissives = remissives.filter((remissive) =>
    remissive.toLowerCase().includes(inputValue)
  );

  const displayLabel = parentHierarchy ? `${label} - ${parentHierarchy}` : label;

  return (
    <div
      className={`optionItem ${isFocused ? "isFocused" : ""}`}
      ref={innerRef}
      {...innerProps}
      // style={{
      //   padding: "10px 12px",
      //   fontSize: "16px",
      //   lineHeight: "1.5",
      //   backgroundColor: isFocused ? "#f0f0f0" : "white",
      //   color: "#333",
      //   cursor: "pointer",
      // }}
    >
      <div className="optionInfo">
        <div className="contentName">
          <span className="optionName">{displayLabel}</span>

          {!!inputValue && !!validRemissives.length && (
            <div className="remissivesList">
              {validRemissives.map((remissive, index) => {
                return (
                  <div className="remissiveItem" key={index}>
                    <div className="remissiveTag">rem</div>
                    <span className="remissiveText">{remissive}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OptionThesaurus;
